import { Controller } from 'stimulus'
import { isEditingBuilderDoc, isPreviewingBuilderDoc } from './editor/helpers'
import { getCurrentBreakpointKey } from './breakpoint'
import './popup_component.scss'

export default class extends Controller {
  initialize() {
    if (!isEditingBuilderDoc() && !isPreviewingBuilderDoc())
      this.setupTriggers()
  }

  closePopup() {
    // Use modal:close (not modal:hide) so the X button runs ModalComponent#close, which stops any
    // playing video — matching the Esc and click-outside paths. modal:hide skips stopVideo.
    this.dispatch('modal:close', { prefix: false })
  }

  beforeModalHide(e) {
    if (isEditingBuilderDoc()) {
      e.preventDefault()

      this.dispatch('togglePopupNode', {
        target: window.top.document,
        detail: {
          nodeId: this.element.dataset.nodeId,
          forceHide: true,
        },
      })
    }
  }

  /* ==== Triggers ======
   * Multiple triggers can be active at any time.
   * On top of this a give trigger may only be active for a given breakpoint
   */
  setupTriggers() {
    this.setupExitIntentTriggers()
    this.setupPageLoadTriggers()
    this.setupScrollTriggers()
    this.setupManualTriggers()
  }

  setupExitIntentTriggers() {
    const breakpoints = this.breakpointsForTrigger('exit-intent')
    if (breakpoints.length == 0) return

    document.body.addEventListener('mouseleave', () => {
      if (!breakpoints.includes(getCurrentBreakpointKey())) return
      this.showPopupIfNotAlreadyShown()
    })
  }

  setupManualTriggers() {
    // TODO: Needs to be tweaked when we allow multiple popups. Both on the trigger side as well as here.
    //       Then, we'd have to allow people to specify which popup they need to open. The data attribute can be the id of the popup node or sometihing :)
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-open-popup]')) {
        this.showPopupIfNotAlreadyShown(true)
      }
    })
  }

  setupPageLoadTriggers() {
    const breakpoints = this.breakpointsForTrigger('page-load')
    if (breakpoints.length == 0) return
    if (!breakpoints.includes(getCurrentBreakpointKey())) return

    const delay = parseInt(this.element.dataset.triggerPageLoadDelay) || 500
    setTimeout(this.showPopupIfNotAlreadyShown, delay)
  }

  setupScrollTriggers() {
    const breakpoints = this.breakpointsForTrigger('scroll')
    if (breakpoints.length == 0) return

    const percentage = parseFloat(this.element.dataset.triggerScrollPercentage)

    document.addEventListener('scroll', (e) => {
      if (!breakpoints.includes(getCurrentBreakpointKey())) return

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight
      const scrollPercentage = (scrollTop / scrollHeight) * 100

      if (scrollPercentage >= percentage && !this._percentageScrollTriggered) {
        this.showPopupIfNotAlreadyShown(true)
        this._percentageScrollTriggered = true
      }
    })
  }

  showPopupIfNotAlreadyShown = (force) => {
    if (this._alreadyShown && !force) return
    this._alreadyShown = true
    this.dispatch('modal:show', { prefix: false })
  }

  // Given a trigger name, returns the breakpoint where this trigger should be active from the data attr
  breakpointsForTrigger(triggerName) {
    return (
      this.element
        .getAttribute(`data-trigger-${triggerName}`)
        ?.trim()
        ?.split(' ') || []
    )
  }
}
